import type { Item } from '@easymoving/types';

/** The label to show for an item: the user's nickname if set, else its name. */
export function itemLabel(item: Pick<Item, 'name' | 'nickname'>): string {
  return item.nickname?.trim() || item.name;
}
